import { render } from "./ApiKeyManagement.vue?vue&type=template&id=d980f0ba&scoped=true"
import script from "./ApiKeyManagement.vue?vue&type=script&lang=js"
export * from "./ApiKeyManagement.vue?vue&type=script&lang=js"

import "./ApiKeyManagement.vue?vue&type=style&index=0&id=d980f0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d980f0ba"]])

export default __exports__